import React from 'react'
import {useIntl, FormattedMessage} from 'react-intl'
import {
    Box,
    useMultiStyleConfig,
    Text,
    HStack,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useBasketTotalItems} from '../../../hooks/use-basket-total-items'

const CartTitle = () => {
    const style = useMultiStyleConfig('Cart', {})
    const {header} = style
    const {formatMessage} = useIntl()
    const totalItems = useBasketTotalItems()

    return (
        <Box {...header?.headerContainer}>
            <HStack {...header?.stack}>
                <Text {...header?.title}>
                    {formatMessage({
                        defaultMessage: 'Basket',
                        id: 'cart_title.title.cart_title',
                    })}
                </Text>
                <Text {...header?.quantity}>
                    {totalItems === 1 ? (
                        <FormattedMessage
                            defaultMessage="({itemCount} item)"
                            id="cart_title.title.cart_num_of_items"
                            values={{itemCount: totalItems}}
                        />
                    ) : (
                        <FormattedMessage
                            defaultMessage="({itemCount} items)"
                            id="cart_title.title.cart_num_of_items_plural"
                            values={{itemCount: totalItems}}
                        />
                    )}
                </Text>
            </HStack>
        </Box>
    )
}

export default CartTitle
